"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactRouterDom = require("react-router-dom");

var _react = require("react");

var _useCache3 = _interopRequireDefault(require("./useCache"));

var _useGraph3 = _interopRequireDefault(require("./useGraph"));

var _excluded = ["*"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var usePage = function usePage(_ref) {
  var _cacheState$cache, _cacheState$cache$pat, _cacheState$temp$awye, _cacheState$temp, _cacheState$cache2, _cacheState$cache3, _cacheState$page2, _cacheState$page4, _cacheState$page6;

  var path = _ref.path,
      dynamicPath = _ref.dynamicPath,
      projection = _ref.projection,
      resolverField = _ref.resolverField,
      _ref$fromCache = _ref.fromCache,
      fromCache = _ref$fromCache === void 0 ? true : _ref$fromCache;

  var _useCache = (0, _useCache3["default"])(),
      _useCache2 = _slicedToArray(_useCache, 2),
      cacheState = _useCache2[0],
      update = _useCache2[1].update;

  var _useLocation = (0, _reactRouterDom.useLocation)(),
      pathname = _useLocation.pathname;

  var navigate = (0, _reactRouterDom.useNavigate)();

  var _useState = (0, _react.useState)(pathname !== null && pathname !== void 0 && pathname.length ? cacheState === null || cacheState === void 0 ? void 0 : (_cacheState$cache = cacheState.cache) === null || _cacheState$cache === void 0 ? void 0 : (_cacheState$cache$pat = _cacheState$cache[pathname]) === null || _cacheState$cache$pat === void 0 ? void 0 : _cacheState$cache$pat.awyesId : undefined),
      _useState2 = _slicedToArray(_useState, 2),
      awyesId = _useState2[0],
      setAwyesId = _useState2[1];

  var _useState3 = (0, _react.useState)({
    pathname: pathname
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      state = _useState4[0],
      setState = _useState4[1];

  var _useGraph = (0, _useGraph3["default"])({
    projection: projection,
    resolverField: resolverField
  }),
      _useGraph2 = _slicedToArray(_useGraph, 2),
      _useGraph2$ = _useGraph2[0],
      loading = _useGraph2$.loading,
      error = _useGraph2$.error,
      complete = _useGraph2$.complete,
      data = _useGraph2$.data,
      request = _useGraph2[1].request;

  var cache = awyesId !== null && awyesId !== void 0 && awyesId.length ? (_cacheState$temp$awye = cacheState === null || cacheState === void 0 ? void 0 : (_cacheState$temp = cacheState.temp) === null || _cacheState$temp === void 0 ? void 0 : _cacheState$temp[awyesId]) !== null && _cacheState$temp$awye !== void 0 ? _cacheState$temp$awye : cacheState === null || cacheState === void 0 ? void 0 : (_cacheState$cache2 = cacheState.cache) === null || _cacheState$cache2 === void 0 ? void 0 : _cacheState$cache2[awyesId] : pathname !== null && pathname !== void 0 && pathname.length ? cacheState === null || cacheState === void 0 ? void 0 : (_cacheState$cache3 = cacheState.cache) === null || _cacheState$cache3 === void 0 ? void 0 : _cacheState$cache3[pathname] : undefined;
  (0, _react.useEffect)(function () {
    if ((state === null || state === void 0 ? void 0 : state.pathname) !== pathname) {
      var _cacheState$page, _cacheState$page$awye;

      if (cacheState !== null && cacheState !== void 0 && (_cacheState$page = cacheState.page) !== null && _cacheState$page !== void 0 && (_cacheState$page$awye = _cacheState$page.awyesId) !== null && _cacheState$page$awye !== void 0 && _cacheState$page$awye.length) {
        setAwyesId(cacheState.page.awyesId);
      } else {
        setAwyesId(undefined);
      }
    }
  }, [state === null || state === void 0 ? void 0 : state.pathname, pathname, cacheState === null || cacheState === void 0 ? void 0 : (_cacheState$page2 = cacheState.page) === null || _cacheState$page2 === void 0 ? void 0 : _cacheState$page2.awyesId]);
  var requestWithVars = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _doRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _state$url, _cacheState$page3, _cacheState$page3$awy;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(state !== null && state !== void 0 && (_state$url = state.url) !== null && _state$url !== void 0 && _state$url.length && !(cacheState !== null && cacheState !== void 0 && (_cacheState$page3 = cacheState.page) !== null && _cacheState$page3 !== void 0 && (_cacheState$page3$awy = _cacheState$page3.awyesId) !== null && _cacheState$page3$awy !== void 0 && _cacheState$page3$awy.length))) {
                _context.next = 5;
                break;
              }

              doRequest.aborted = false;
              console.log("Finding page for: ".concat(state === null || state === void 0 ? void 0 : state.url));
              _context.next = 5;
              return request({
                where: {
                  filter: {
                    primary: {
                      url: state === null || state === void 0 ? void 0 : state.url
                    }
                  },
                  limit: 1
                }
              }, function () {
                return doRequest.aborted;
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function doRequest() {
      return _doRequest.apply(this, arguments);
    }

    return doRequest;
  }(), [request, state === null || state === void 0 ? void 0 : state.url, cacheState === null || cacheState === void 0 ? void 0 : (_cacheState$page4 = cacheState.page) === null || _cacheState$page4 === void 0 ? void 0 : _cacheState$page4.awyesId]);
  var doNothing = (0, _react.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            console.log("Cached used for: ".concat(window.location.pathname));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), []);
  (0, _react.useEffect)(function () {
    var _matchPath, _matchPath2;

    var _ref3 = (_matchPath2 = (0, _reactRouterDom.matchPath)(path, pathname)) !== null && _matchPath2 !== void 0 ? _matchPath2 : {},
        url = _ref3.pathnameBase,
        _ref3$params = _ref3.params;

    _ref3$params = _ref3$params === void 0 ? {} : _ref3$params;

    var _ = _ref3$params['*'],
        params = _objectWithoutProperties(_ref3$params, _excluded);

    var _ref4 = dynamicPath ? (_matchPath = (0, _reactRouterDom.matchPath)(dynamicPath, pathname)) !== null && _matchPath !== void 0 ? _matchPath : {} : {},
        _ref4$params = _ref4.params,
        dynamicParams = _ref4$params === void 0 ? {} : _ref4$params;

    var optionalParams = Object.keys(dynamicParams).reduce(function (obj, key) {
      if (!(key in params)) {
        obj[key] = dynamicParams[key];
      }

      return obj;
    }, {});
    setState(function (oldState) {
      var _oldState$url, _cacheState$page5, _cacheState$page5$awy, _newState$data, _newState$data$awyesI;

      var urlsMatch = !(oldState !== null && oldState !== void 0 && (_oldState$url = oldState.url) !== null && _oldState$url !== void 0 && _oldState$url.length) || oldState.url === url;

      var newState = _objectSpread(_objectSpread({}, oldState), {}, {
        url: url,
        params: params,
        optionalParams: optionalParams,
        pathname: pathname
      });

      if (!urlsMatch && (!(cacheState !== null && cacheState !== void 0 && (_cacheState$page5 = cacheState.page) !== null && _cacheState$page5 !== void 0 && (_cacheState$page5$awy = _cacheState$page5.awyesId) !== null && _cacheState$page5$awy !== void 0 && _cacheState$page5$awy.length) || (_newState$data = newState.data) !== null && _newState$data !== void 0 && (_newState$data$awyesI = _newState$data.awyesId) !== null && _newState$data$awyesI !== void 0 && _newState$data$awyesI.length && newState.data.awyesId !== cacheState.page.awyesId)) {
        console.log('Page change detected!');
        newState.complete = false;
        delete newState.data;
      }

      return newState;
    });
  }, [pathname, path, dynamicPath, cacheState === null || cacheState === void 0 ? void 0 : (_cacheState$page6 = cacheState.page) === null || _cacheState$page6 === void 0 ? void 0 : _cacheState$page6.awyesId]);
  (0, _react.useEffect)(function () {
    var defaultData = awyesId !== null && awyesId !== void 0 && awyesId.length ? {
      awyesId: awyesId
    } : undefined;
    var data = awyesId !== null && awyesId !== void 0 && awyesId.length && (cache === null || cache === void 0 ? void 0 : cache.awyesId) === awyesId ? cache !== null && cache !== void 0 ? cache : defaultData : defaultData;
    setState(function (oldState) {
      return _objectSpread(_objectSpread({}, oldState), {}, {
        loading: loading,
        error: error,
        complete: !!(complete || !error && !loading && cache),
        data: data
      });
    });
  }, [awyesId, loading, error, complete, cache]);
  (0, _react.useEffect)(function () {
    if (complete) {
      var _data$items, _typeData$awyesId;

      var typeData = data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items[0];

      if (typeData !== null && typeData !== void 0 && (_typeData$awyesId = typeData.awyesId) !== null && _typeData$awyesId !== void 0 && _typeData$awyesId.length) {
        setAwyesId(typeData.awyesId);
        update({
          awyesId: typeData.awyesId,
          data: typeData
        });
      } else {
        setAwyesId(undefined);
      }
    }
  }, [complete, data, update]);
  (0, _react.useEffect)(function () {
    var _cache$url, _cacheState$page7, _cacheState$page7$awy;

    if (awyesId !== null && awyesId !== void 0 && awyesId.length && cache !== null && cache !== void 0 && (_cache$url = cache.url) !== null && _cache$url !== void 0 && _cache$url.length && cacheState !== null && cacheState !== void 0 && (_cacheState$page7 = cacheState.page) !== null && _cacheState$page7 !== void 0 && (_cacheState$page7$awy = _cacheState$page7.awyesId) !== null && _cacheState$page7$awy !== void 0 && _cacheState$page7$awy.length && awyesId === cacheState.page.awyesId) {
      var _cacheState$page$rout, _cacheState$page$rout2, _cache$url$replace$sp, _cacheState$page$rout3;

      var routeParts = (_cacheState$page$rout = (_cacheState$page$rout2 = cacheState.page.route) === null || _cacheState$page$rout2 === void 0 ? void 0 : _cacheState$page$rout2.replace(/^\/|\/$/g, '').split('/')) !== null && _cacheState$page$rout !== void 0 ? _cacheState$page$rout : [];
      var urlParts = (_cache$url$replace$sp = cache.url.replace(/^\/|\/$/g, '').split('/')) !== null && _cache$url$replace$sp !== void 0 ? _cache$url$replace$sp : [];
      var combined = "/".concat(routeParts.map(function (part, index) {
        var _urlParts$index;

        return (_urlParts$index = urlParts[index]) !== null && _urlParts$index !== void 0 && _urlParts$index.length ? urlParts[index] : part;
      }).join('/')).concat((_cacheState$page$rout3 = cacheState.page.route) !== null && _cacheState$page$rout3 !== void 0 && _cacheState$page$rout3.endsWith('/') ? '/' : '').replace(/\/+/g, '/');

      if (pathname !== combined) {
        navigate(combined, {
          replace: true
        });
      }
    }
  }, [awyesId, cache === null || cache === void 0 ? void 0 : cache.url, cacheState === null || cacheState === void 0 ? void 0 : cacheState.page, pathname, navigate]);
  return [(state === null || state === void 0 ? void 0 : state.pathname) === pathname ? state : _objectSpread(_objectSpread({}, state), {}, {
    complete: false,
    data: undefined
  }), {
    request: fromCache && awyesId !== null && awyesId !== void 0 && awyesId.length && state !== null && state !== void 0 && state.data ? doNothing : requestWithVars
  }];
};

var _default = usePage;
exports["default"] = _default;